<app-storage-stats [stats]="storageStats | async"></app-storage-stats>

<table mat-table [dataSource]="data" matSort>
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Id.</th>
    <td mat-cell *matCellDef="let element">{{ element.id }}</td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
    <td mat-cell *matCellDef="let element">{{ element.name }}</td>
  </ng-container>

  <ng-container matColumnDef="createdAt">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Date de création</th>
    <td mat-cell *matCellDef="let element">{{ element.createdAt | date }}</td>
  </ng-container>

  <ng-container matColumnDef="size">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Taile</th>
    <td mat-cell *matCellDef="let element">{{ element.size | bytes }}</td>
  </ng-container>

  <ng-container matColumnDef="encrypted">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Encrypté</th>
    <td mat-cell *matCellDef="let element">
      <mat-icon *ngIf="element.encrypted" matTooltip="Encrypté" matTooltipShowDelay="1000" color="primary"> fingerprint</mat-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="hasRef">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Réferencé</th>
    <th></th>
    <td mat-cell *matCellDef="let element">
      <mat-icon *ngIf="element.hasRef" matTooltip="Réferencé" matTooltipShowDelay="1000">insert_drive_file</mat-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="hasFile">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Fichier</th>
    <td mat-cell *matCellDef="let element">
      <ng-container *ngIf="!element.hasFile">
        <button mat-icon-button disabled>
          <mat-icon matTooltip="Fichier manquant" matTooltipShowDelay="1000" color="warn">warning</mat-icon>
        </button>
      </ng-container>

      <ng-container *ngIf="element.hasFile">
        <button *ngIf="element.hasRef" mat-icon-button (click)="download(element)" matTooltip="Télécharger" matTooltipShowDelay="1000">
          <mat-icon style="color: green">download</mat-icon>
        </button>

        <button
          *ngIf="!element.hasRef"
          [disabled]="!element.hasRef"
          mat-icon-button
          (click)="download(element)"
          matTooltip="Télécharger"
          matTooltipShowDelay="1000"
        >
          <mat-icon style="color: lightgrey">download</mat-icon>
        </button></ng-container
      >
    </td>
  </ng-container>

  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Actions</th>
    <td mat-cell *matCellDef="let element">
      <div class="btn-group">
        <button
          mat-icon-button
          [disabled]="element.hasRef"
          (click)="addDescription(element)"
          matTooltip="Créer la référence"
          matTooltipShowDelay="1000"
        >
          <mat-icon>description</mat-icon>
        </button>
        <button
          mat-icon-button
          [disabled]="element.encrypted || !element.hasFile || !element.hasRef"
          (click)="encrypt(element)"
          matTooltip="Encrypter le fichier"
          matTooltipShowDelay="1000"
        >
          <mat-icon>enhanced_encryption</mat-icon>
        </button>

        <button mat-icon-button (click)="remove(element)" matTooltip="Supprimer" matTooltipShowDelay="1000"><mat-icon>delete</mat-icon></button>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>

<mat-paginator [pageSizeOptions]="[20, 50, 100]" showFirstLastButtons aria-label="Select page of periodic elements"> </mat-paginator>
